import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";

import { FileNodeView } from "../nodeViews/FileNodeView";

export type FileAttrs = { src: string | null; name: string };

export type FileOptions = {
  onClick?: (src: string | null, attrs: FileAttrs) => void;
};

declare module "@tiptap/core" {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface Commands<ReturnType> {
    file: {
      insertFile: (attrs: { name: string; src: string }) => ReturnType;
      updateFile: (attrs: Partial<FileAttrs>) => ReturnType;
      removeFile: () => ReturnType;
    };
  }
}

export const File = Node.create<FileOptions>({
  name: "file",

  group: "inline",

  inline: true,

  atom: true,

  selectable: true,

  addOptions() {
    return {};
  },

  addAttributes() {
    return {
      src: {
        default: null,
        parseHTML: (element) =>
          element.getAttribute("data-url") || element.getAttribute("src"),
      },
      name: {
        default: "",
        parseHTML: (element) =>
          element.getAttribute("data-name") ||
          element.getAttribute("name") ||
          element.textContent ||
          "",
      },
    };
  },

  parseHTML() {
    return [{ tag: 'span[data-ext="file"]' }];
  },

  renderHTML({ node, HTMLAttributes }) {
    return [
      "span",
      mergeAttributes(HTMLAttributes, { "data-ext": "file" }),
      ((node.attrs.name as string) || "").trim(),
    ];
  },

  renderText({ node }) {
    return ((node.attrs.name as string) || "").trim();
  },

  addNodeView() {
    return ReactNodeViewRenderer(FileNodeView);
  },

  addCommands() {
    return {
      insertFile:
        (attrs) =>
        ({ commands }) =>
          commands.insertContent({ type: this.name, attrs }),
      updateFile:
        (attrs) =>
        ({ commands }) =>
          commands.updateAttributes(this.name, attrs),
      removeFile:
        () =>
        ({ commands, editor }) => {
          if (!editor.isActive(this.name)) {
            return false;
          }
          return commands.deleteSelection();
        },
    };
  },
});
